<template>
    <modal-controller-base contentClass="light-light-background">
        <template #header>
            <custom-header back-button :title="$t('titleRoute.productDetails')">
                <template #start>
                    <ion-button
                        @click="modalController.dismiss()"
                        class="purple-light-color"
                    >
                        <ion-icon :icon="chevronBack"/>
                        {{ $t('button.back') }}
                    </ion-button>
                </template>
            </custom-header>
        </template>

        <catalog-product
            contained
            :product="product"
            :target-stock="product.targetStock ?? 0"
            @back="modalController.dismiss()"
            read-only
        />
    </modal-controller-base>
</template>

<script setup lang="ts">
import { IonButton, IonIcon, modalController } from "@ionic/vue";

import CatalogProduct from "@/components/modal/CatalogProduct.vue";
import ModalControllerBase from "@/components/modal/modalControllerModals/ModalControllerBase.vue";
import CustomHeader from "@/components/basePageElements/CustomHeader.vue";

import { CatalogItem } from "@/types/supplier";

import { chevronBack } from "ionicons/icons";

defineProps<{ product: CatalogItem }>()
</script>
